import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import StepProgress from "../pages/StepProgress";

const WhatsNext = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const showStepper = location.state?.fromRegistration ?? false;
  const showGenerateButton = location.state?.fromProfile ?? false;

  return (
    <Box
      sx={{
        backgroundColor: "#f8f9e9",
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        py: 2,
        px: 3,
      }}
    >
      {/* Stepper: Only Show if Navigated from Registration Page */}
      {showStepper && <StepProgress />}

      <Box
        sx={{
          backgroundColor: "#f8f9e9",
          minHeight: "70vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          py: 2,
          px: 3,
        }}
      >
        {/* Title */}
        <Grid item xs={12} sx={{ textAlign: "center" }}>
          <Typography variant="h3" sx={{ fontWeight: "bold", color: "red" }}>
            What's <span style={{ color: "#FAD707" }}>Next?</span>
          </Typography>
        </Grid>

        {/* Paragraph Content */}
        <Typography
          variant="body1"
          sx={{
            maxWidth: "700px",
            textAlign: "center",
            mt: 2,
            fontSize: "1.1rem",
            color: "#333",
          }}
        >
          To ensure collective progress, we request members to register as a
          <strong> New Member</strong> through our online portals:
          <a
            href="https://tkstrust.org/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "none" }}
          >
            {" "}
            TKSTrust Registration
          </a>{" "}
          
        </Typography>

        <Typography
          variant="body1"
          sx={{
            maxWidth: "700px",
            textAlign: "center",
            mt: 2,
            fontSize: "1.1rem",
            color: "#333",
          }}
        >
          The first-time registration fee for new members is <strong>₹2,000</strong>.
          The membership ID card will be issued with unique QR code and can be accessed via our existing portals:
          <a
            href="https://tkstrust.org/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "none" }}
          >
            {" "}
            TKSTrust Registration
          </a>{" "}
          Registered members will receive regular updates from us.
        </Typography>

        <Typography
          variant="body1"
          sx={{
            maxWidth: "700px",
            textAlign: "center",
            mt: 2,
            fontSize: "1.1rem",
            color: "#333",
          }}
        >
          For further inquiries, please contact the
          <strong> Central Coordinator</strong> via <strong> WhatsApp:</strong>
          <a
            href="https://wa.me/9841818740"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue", textDecoration: "none" }}
          >
            {" "}
            +91 9841818740
          </a>
          .
        </Typography>

        {/* Generate ID Card Button: Only Show if Navigated from Profile Page */}
        {showGenerateButton && (
          <Box className="mt-8 flex space-x-4">
            <Button
              variant="contained"
              className="bg-red-500 text-white px-6 py-2 rounded-lg"
              style={{ backgroundColor: "#4CAF50" }}
              onClick={() => {
                navigate("/membership");
                window.scrollTo(0, 0);
            }}
            >
              Generate ID card
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default WhatsNext;
